import $ from "jquery";
import React, { Suspense, useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";

import AllItems from './Items/AllItems';

import StoreCategory from './Category/StoreCategory';
import StoreDiscount from './Discount/StoreDiscount';
import StoreSettings from './StoreSettings/StoreSettings';

import { useContext } from 'react';
import UserBasicInfoQRContext from '../../../components/Context/UserBasicInfoQRContext';
import DeliveryZone from './DeliveryZone/DeliveryZone';
import DineInPoint from './DineInPoint/DineInPoint';
import RequestedItems from './Items/RequestedItems';
import StorePickup from './PickupPoint/StorePickup';




export default function Store() {

    const companyInfo = useContext(UserBasicInfoQRContext);


    const [salesSummary, setSalesSummary] = useState({});
    const [currentTab, setCurrentTab] = useState("AllItems");


    const handleTab = (tabId, event) => {
        $(".tablinks").removeClass("current");
        $(event.target).addClass("current");
        setCurrentTab(tabId);
    }


    const { state } = useLocation();

    useEffect(() => {
        if (state?.tab !== null && state?.tab !== undefined && state?.tab !== "") {
            if (state?.tab === "requested-items") {
                $(".tablinks").eq(1).trigger("click");
            }
            if (state?.tab === "store-category") {
                $(".tablinks").eq(2).trigger("click");
            }
            if (state?.tab === "discount") {
                $(".tablinks").eq(3).trigger("click");
            }
            // if (state?.tab === "pickup") {
            //     $(".tablinks").eq(4).trigger("click");
            // }
        }
    }, [state]);


    return (
        <div className="custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20 ">


            {(companyInfo?.id === null || companyInfo?.id === "" || companyInfo?.id === undefined) ?
                <table className="custom-details-table w-full mt-0 mb-2">
                    <tbody>
                        <tr>
                            <td className="font-semibold text-base">
                                Before proceeding, please select a company.
                            </td>
                        </tr>
                    </tbody>
                </table>
                :
                <>

                    {/* TAB SWITCHER */}
                    <div className="tab w-full mb-4 border-b border-gray-200 dark:border-gray-700">
                        <ul className="flex flex-wrap -mb-px text-sm font-medium text-center" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
                            <li className="mr-2" role="presentation">
                                <button className="tablinks current inline-block p-4 border-b-2 rounded-t-lg" id="allItems-tab" data-tabs-target="#allItems" type="button" role="tab" aria-controls="allItems" aria-selected="false" onClick={(event) => handleTab("AllItems", event)}>Items</button>
                            </li>
                            <li className="mr-2" role="presentation">
                                <button className="tablinks inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300" id="requestedItems-tab" data-tabs-target="#requestedItems" type="button" role="tab" aria-controls="requestedItems" aria-selected="false" onClick={(event) => handleTab("requested-items", event)}>Requested Items</button>
                            </li>
                            <li className="mr-2" role="presentation">
                                <button className="tablinks inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300" id="categories-tab" data-tabs-target="#categories" type="button" role="tab" aria-controls="categories" aria-selected="false" onClick={(event) => handleTab("categories", event)}>Categories</button>
                            </li>
                            <li role="presentation">
                                <button className="tablinks inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300" id="discount-tab" data-tabs-target="#discount" type="button" role="tab" aria-controls="discount" aria-selected="false" onClick={(event) => handleTab("discount", event)}>Discount</button>
                            </li>

                            <li role="presentation">
                                <button className="tablinks inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300" id="settingsAndTiming-tab" data-tabs-target="#settingsAndTiming" type="button" role="tab" aria-controls="settingsAndTiming" aria-selected="false" onClick={(event) => handleTab("settings-and-timing", event)}>Settings & Timing</button>
                            </li>
                            {/* 
                            <li role="presentation">
                                <button className="tablinks inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300" id="pickupPoint-tab" data-tabs-target="#pickupPoint" type="button" role="tab" aria-controls="pickupPoint" aria-selected="false" onClick={(event) => handleTab("pickup-point", event)}>Pickup Point</button>
                            </li>
                            <li role="presentation">
                                <button className="tablinks inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300" id="dineInPoint-tab" data-tabs-target="#dineInPoint" type="button" role="tab" aria-controls="dineInPoint" aria-selected="false" onClick={(event) => handleTab("dine-in-point", event)}>Dine In Point</button>
                            </li> 
                            <li role="presentation">
                                <button className="tablinks inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300" id="deliveryZone-tab" data-tabs-target="#deliveryZone" type="button" role="tab" aria-controls="deliveryZone" aria-selected="false" onClick={(event) => handleTab("delivery-zone", event)}>Delivery Zone</button>
                            </li>
                            */}
                        </ul>
                    </div>






                    <div className='tabcontentbody py-3 px-0'>
                        <div id="view-profile" className="tabcontent" style={{ display: "block", paddingLeft: "0px", paddingRight: "0px" }}>
                            <Suspense fallback="Loading...">

                                {(() => {
                                    switch (currentTab) {
                                        case "AllItems":
                                            return <AllItems props={salesSummary}></AllItems>;
                                        case "requested-items":
                                            return <RequestedItems props={salesSummary} />;
                                        case "categories":
                                            return <StoreCategory props={salesSummary} currentTab={currentTab}></StoreCategory>;
                                        case "discount":
                                            return <StoreDiscount></StoreDiscount>;
                                        case "settings-and-timing":
                                            return <StoreSettings></StoreSettings>;
                                        {/* case "pickup-point":
                                            return <StorePickup />;
                                        case "dine-in-point":
                                            return <DineInPoint />
                                        case "delivery-zone":
                                            return <DeliveryZone /> */}
                                        default:
                                            return <>No page found</>;
                                    }
                                })()}

                            </Suspense>
                        </div>
                    </div>

                </>
            }


            <style>{`
                .custom-scroll-auto { 
                    overflow-x: hidden;
                }

                .tab button:hover::after, .tab button.current::after { 
                    width: 120% !important;
                    margin-left: -10% !important;
                }
                `}</style>


        </div>
    )

}